const FITCHECK_SERVICE_URL = "https://o2ksqiwued.execute-api.us-east-1.amazonaws.com/dev";

export { FITCHECK_SERVICE_URL };
